import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import swal from "sweetalert";

const ItemTabBar = ({ itemId, hasUnsavedChanges, onTabChange }) => {
  const location = useLocation();
  const navigate = useNavigate();
  
  const tabs = [
    { 
      id: "general", 
      label: "General", 
      link: `/items/updateItem/${itemId}`,
      icon: "fa fa-info-circle"
    },
    { 
      id: "inventory", 
      label: "Inventory", 
      link: `/items/updateItemInventory/${itemId}`,
      icon: "fa fa-warehouse"
    },
    { 
      id: "inventoryLedger", 
      label: "Inventory Ledger", 
      link: `/items/updateItemInventoryLedger/${itemId}`,
      icon: "fa fa-book"
    },
  ];

  const getActiveTab = () => {
    if (location.pathname.includes("updateItemInventoryLedger")) {
      return "inventoryLedger";
    }
    if (location.pathname.includes("updateItemInventory")) {
      return "inventory";
    }
    return "general";
  };

  const activeTab = getActiveTab();

  const handleTabClick = async (e, tab) => {
    // If clicking on the same tab, do nothing
    if (tab.id === activeTab) {
      e.preventDefault();
      return;
    }

    // If there are unsaved changes, show warning
    if (hasUnsavedChanges) {
      e.preventDefault();
      const result = await swal({
        title: "Unsaved Changes",
        text: "You have unsaved changes. Do you want to save them before switching tabs?",
        icon: "warning",
        buttons: {
          cancel: {
            text: "Cancel",
            value: false,
            visible: true,
            closeModal: true,
          },
          discard: {
            text: "Discard Changes",
            value: "discard",
            visible: true,
            closeModal: true,
          },
          save: {
            text: "Save Changes",
            value: "save",
            visible: true,
            closeModal: true,
          },
        },
        dangerMode: true,
      });

      if (result === "save") {
        // Call the onTabChange callback with 'save' action
        if (onTabChange) {
          const shouldProceed = await onTabChange("save", tab);
          if (shouldProceed) {
            navigate(tab.link);
          }
        }
      } else if (result === "discard") {
        // Call the onTabChange callback with 'discard' action
        if (onTabChange) {
          const shouldProceed = await onTabChange("discard", tab);
          if (shouldProceed) {
            navigate(tab.link);
          }
        }
      }
      // If cancel, do nothing (stay on current tab)
    } else {
      // No unsaved changes, allow navigation
      if (onTabChange) {
        onTabChange("navigate", tab);
      }
    }
  };

  return (
    <ul className="nav nav-tabs nav-tabs-v2 px-3 mb-3">
      {tabs.map((tab) => (
        <li className="nav-item me-2" key={tab.id}>
          <Link
            to={tab.link}
            onClick={(e) => handleTabClick(e, tab)}
            className={`nav-link px-2 ${activeTab === tab.id ? "active" : ""}`}
          >
            <i className={`${tab.icon} me-2`}></i>
            {tab.label}
          </Link>
        </li>
      ))}
    </ul>
  );
};

export default ItemTabBar;
